@use '@lib/assets/styles/main.scss' as *;

$imageSize: 48px;

.wrap {
  padding-left: $imageSize + 8px;
  position: relative;
}

.icon {
  position: absolute;
  top: 0;
  left: 0;
  width: $imageSize;
  img {
    display: block;
    object-fit: cover;
    width: $imageSize;
    height: $imageSize;
    border-radius: 4px;
    border: 1px solid $gray200;
  }
}

.info {
  min-height: 48px;
  display: flex;
  align-items: center;
}
